<template>
  <div>
    <button
      :class="{ 'pd-AddToCart-notAllowed': isDisabled }"
      :data-disable_with="please_wait_text"
      :disabled="isDisabled"
      @click="callPopulate"
      type="button"
      class="btn btn-lg btn-block pd-AddToCart"
    >
      <div v-if="isLoading" class="spinner-border spinner-border-sm mr-2 text-white"></div>
      <i v-else class="icon icon-cart pd-AddToCart_CartIcon"></i>
      {{ add_to_cart_text }}
    </button>
    <transition name="fade">
      <div
        v-if="isSubmitted"
        class="mt-2 d-flex justify-content-between align-items-center flex-wrap"
      >
        <p class="h6 text-muted mb-0">{{ product_added_text }}</p>
        <a :href="cartPath" class="btn btn-sm btn-primary-link">{{ go_to_cart_text }}</a>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "variantPickerSubmitButton",
  props: {
    add_to_cart_text: {
      required: true,
      type: String,
    },
    go_to_cart_text: {
      required: true,
      type: String,
    },
    product_added_text: {
      required: true,
      type: String,
    },
    please_wait_text: {
      required: true,
      type: String,
    },
    cartPath: {
      type: String,
      default: "",
    },
    lyticsActivities: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
      allProductVariants: "variantPicker/allProductVariants",
      isLoading: "shoppingCart/isLoading",
      isSubmitted: "shoppingCart/isSubmitted",
    }),
    variant() {
      return this.allProductVariants.find(variant => variant.id === this.chosenVariant);
    },
    isDisabled() {
      return !this.chosenVariant || this.variant.count_on_hand === 0;
    },
  },
  methods: {
    ...mapActions({
      addProductToCart: "shoppingCart/addProductToCart",
    }),
    callPopulate() {
      if (!this.isDisabled) {
        this.addProductToCart({
          variant_id: this.chosenVariant,
          lyticsActivities: this.lyticsActivities,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration-short;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
